import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Popup, Icon } from 'semantic-ui-react';

export default class StatsTable extends Component {
    render() {
        const {stats, iLevel} = this.props;

        if(!stats || Object.keys(stats).length === 0 ) {
            return null;
        }

        const iLevelRow = iLevel ?
            <Table.Row key='iLevel'>
                <Table.Cell>
                    Adjusted iLevel&nbsp;
                    <Popup
                        trigger={<Icon circular name="info" color='grey' size='small' />}
                        content="The base iLevel, plus adjustments for item rarity"
                    />
                </Table.Cell>
                <Table.Cell textAlign="right">{iLevel}</Table.Cell>
            </Table.Row> : null;

        const statsTableRows = Object.keys(stats).map(s =>
            <Table.Row key={s}>
                <Table.Cell>{s}</Table.Cell>
                <Table.Cell textAlign="right">{stats[s]}</Table.Cell>
            </Table.Row>
        );

        return (
            <Table compact celled>
                <Table.Body>
                    {iLevelRow}
                    {statsTableRows}
                </Table.Body>
            </Table>
        );
    }
}

StatsTable.propTypes = {
    stats: PropTypes.object,
    iLevel: PropTypes.number,
};


// WEBPACK FOOTER //
// ./src/items/detail/summary-card/stats/StatsTable.jsx